'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';

import SearchResultPost from './SearchResultPost';

import { LazyLoader } from '@components/Lazy';
import { logger } from '@logger';

interface SearchLazyLoaderProps {
  query: string;
  sortBy?: string;
  initialPage?: number;
}
export default function SearchLazyLoader({
  query,
  sortBy,
  initialPage = 1,
}: SearchLazyLoaderProps) {
  const [posts, setPosts] = useState<any[]>([]);
  const [page, setPage] = useState(initialPage);
  const [isEnd, setIsEnd] = useState(false);
  const locale = useLocale();

  const onChange = async (isVisible: boolean) => {
    if (!isVisible) {
      return;
    }

    const response = await fetch(
      `${
        process.env.NEXT_PUBLIC_API_PUBLIC
      }/search/${locale}?keywords=${encodeURIComponent(query)}&limit=10&page=${page}&sortBy=${sortBy || 'accuracy'
      }`,
    );

    if (!response.ok) {
      logger.error(
        { locale, query, page, status: response.status },
        'Search: api-gateway responded with an error status',
      );
      setIsEnd(true);

      return;
    }

    // api-gateway potrafi odpowiedzieć 200 z pustym ciałem - patrz komentarz w lib/data.ts
    const body = await response.text();

    if (!body.trim()) {
      logger.error(
        { locale, query, page },
        'Search: empty body received from api-gateway',
      );
      setIsEnd(true);

      return;
    }

    let data;

    try {
      data = JSON.parse(body);
    } catch (error) {
      logger.error(
        { locale, query, page, error },
        'Search: malformed JSON received from api-gateway',
      );
      setIsEnd(true);

      return;
    }

    const result = data?.searchResultsMap?.post?.searchResults ?? [];

    setPosts((_posts) => [..._posts, ...result]);
    setPage((page) => page + 1);

    if (result.length === 0) {
      setIsEnd(true);
    }
  };

  return (
    <>
      {posts.map((item) => (
        <SearchResultPost key={item.postSlug} post={item} />
      ))}
      {!isEnd && (
        <div className="lg:col-span-2">
          <LazyLoader onChange={onChange} />
        </div>
      )}
    </>
  );
}
